import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import '../components/components.css';

// Components
import convertSpecialCharacters from './convertSpecialCharacters';
import convertStringtoHTML from './convertStringtoHTML';
import ImageWithFallBack from './ImageFallBack';
import FullscreenImage from './fullscreenImage';
import ReleasedIcon from './releasedIcon';
import checkGame from './checkGame';

// Images
import NotLikedIcon from '../images/icons/heart-regular-full.svg';
import LikedIcon from '../images/icons/heart-solid-full.svg';
import D1GrimoireIcon from '../images/D1GrimoireIcon.png';
import LoreEntryIcon from '../images/lore entry.png';
import InventoryIcon from '../images/inventory.png';
import BasicIcon from '../images/Patrol.png';
import QuestIcon from '../images/Quest1.png';


interface PostInfo {
  type: string,
  name: string,
  hash: number,
  index: number,
  description: string | undefined,
  subtitle: string | undefined,
  released: string,
  image: string | undefined,
  lorebookname: string | undefined,
  docType: string | undefined,
  goodImage: boolean,
  save: (index: number) => void
  handleScroll: (index: number) => void
}


export default function PostLayout({type, name, description, subtitle, released, image, hash, lorebookname, index, save, handleScroll, docType, goodImage}: PostInfo) {

    const navigate = useNavigate();
    const [liked, setLiked] = useState<boolean>(false);

    const [displayFullImage, setDisplayFullImage] = useState<boolean>(false);
    

    function closeFullscreenImage() {
        setDisplayFullImage(false);
        let ex = document.getElementById("html");
        ex?.classList.remove("overflow-y-hidden");
    }

    function openFullPost() {
        save(index);
        navigate(`/doomscroll/post?hash=${hash}`);
    }

    function updateFullscreenImage(value: boolean) {
        if(value) {
            setDisplayFullImage(true);
            let ex = document.getElementById("html");
            ex?.classList.add("overflow-y-hidden");
            
        }
        else {
            setDisplayFullImage(false);
            let ex = document.getElementById("html");
            ex?.classList.remove("overflow-y-hidden");
        }
    }

    useEffect(() => {
        handleScroll(index);
    },[]);

    if(docType === "Lore Entry") {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="wide" close={closeFullscreenImage} />}
                <div className="post-container" id={hash.toString()}>
                    <div className="top-row">
                        <div className="post-name">
                            <h3>{name}</h3>
                        </div>
                        <span className="post-category">Lore Entry
                            <span className="image-container"><img src={LoreEntryIcon} /></span>
                        </span>
                    </div>

                    <div className="post-content">
                        <div className="flavor-text">{subtitle}</div>

                        {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                    </div>

                    <div className="image-container post-image" onClick={() => {updateFullscreenImage(true)}}>
                        <ImageWithFallBack src={image} image_type="Lore Entry" alt="" />
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>} {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>

                    <div className="bg-clickable-post" onClick={openFullPost}/>                
                </div>
            </>
        );
    }
    else if(docType === "Lore Book" || type === "Lore Book") {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="wide" close={closeFullscreenImage} />}
                <div className="post-container" id={hash.toString()}>
                    <div className="top-row">
                        <div className="post-name">
                            <h3>{name}</h3>
                            <div className="lorebookname">{lorebookname}</div>
                        </div>
                        
                        <span className="post-category">Lore Book
                            <span className="image-container"><img src={LoreEntryIcon} /></span>
                        </span>
                    </div>

                    <div className="post-content">
                        <div className="flavor-text">{subtitle}</div>

                        {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                    </div>

                    <div className="image-container post-image" onClick={() => {updateFullscreenImage(true)}}>
                        <ImageWithFallBack src={image} image_type="Lore Entry" alt="" />
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>} {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>

                    <div className="bg-clickable-post" onClick={openFullPost}/>                
                </div>
            </>
        );
    }
    else if(type === "Quest") {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="icon" close={closeFullscreenImage} />}
                <div className="post-container quest" id={hash.toString()}>
                    <div className="top-row">
                        <h3>{name}</h3>
                        <span className="post-category">Quest
                            <span className="image-container"><img src={QuestIcon} /></span>
                        </span>
                    </div>

                    <div className="post-info">
                        <div className="image-container post-image" onClick={() => {updateFullscreenImage(true)}}>
                            <ImageWithFallBack src={image} image_type={type} alt="" />
                        </div>

                        <div className="post-content">
                            {/* {subtitle.length !== 0 && <div className="flavor-text">{convertStringtoHTML(subtitle)}</div>} */}

                            {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                        </div>
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>} {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>
                
                    <div className="bg-clickable-post" onClick={openFullPost}/>
                </div>
            </>
            
        );
    }
    // Destiny 2 Item - icon
    else if(docType === "Item" && !goodImage && !checkGame(released)) {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="icon" close={closeFullscreenImage} />}
                <div className="post-container quest" id={hash.toString()}>
                    <div className="top-row">
                        <h3>{name}</h3>
                        <span className="post-category">{type} {goodImage}
                            <span className="image-container"><img src={InventoryIcon} /></span>
                        </span>
                    </div>

                    <div className="post-info">
                        <div className="image-container post-image" onClick={() => {updateFullscreenImage(true)}}>
                            <ImageWithFallBack src={image} image_type={type} alt="" />
                        </div>

                        <div className="post-content">
                            {subtitle !== null && <div className="flavor-text">{convertStringtoHTML(subtitle)}</div>}
                            {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                        </div>
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>}
                            {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>

                    <div className="bg-clickable-post" onClick={openFullPost}/>            
                </div>
            </>
        );
    }
    // Destiny 2 Item - image
    else if(docType === "Item" && goodImage && !checkGame(released)) {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="wide" close={closeFullscreenImage} />}
                <div className="post-container" id={hash.toString()}>
                    <div className="top-row">
                        <h3>{name}</h3>
                        <span className="post-category">{type}
                            <span className="image-container"><img src={InventoryIcon} /></span>
                        </span>
                    </div>

                    <div className="post-content">
                        {subtitle !== null && <div className="flavor-text">{convertStringtoHTML(subtitle)}</div>}
                        {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                    </div>

                    <div className="image-container post-image" onClick={() => {updateFullscreenImage(true)}}>
                        <ImageWithFallBack src={image} image_type="Lore Entry" alt="" />
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>}
                            {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>

                    <div className="bg-clickable-post" onClick={openFullPost}/>            
                </div>
            </>
        );
    }
    // Destiny 1 Item
    else if(docType === "Item" && checkGame(released)) {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="icon" close={closeFullscreenImage} />}
                <div className="post-container quest" id={hash.toString()}>
                    <div className="top-row">
                        <h3>{name}</h3>
                        <span className="post-category"> {type}
                            <span className="image-container"><img src={InventoryIcon} /></span>
                        </span>
                    </div>

                    <div className="post-info">
                        <div className="image-container post-image item" onClick={() => {updateFullscreenImage(true)}}>
                            <ImageWithFallBack src={image} image_type={type} alt="" />
                        </div>

                        <div className="post-content">
                            {/* {subtitle.length !== 0 && <div className="flavor-text">{convertStringtoHTML(subtitle)}</div>} */}

                            {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                        </div>
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>} {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>
                
                    <div className="bg-clickable-post" onClick={openFullPost}/>
                </div>
            </>
        );
    }
    else if(type ==="Grimoire" && checkGame(released)) {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="tall" close={closeFullscreenImage} />}
                <div className="post-container grimoire"id={hash.toString()}>
                    <div className="top-row">
                        <div className="post-name">
                            <h3>{convertSpecialCharacters(name)}</h3>
                        </div>
                        <span className="post-category">Grimoire
                            <span className="image-container"><img src={D1GrimoireIcon} /></span>
                        </span>
                    </div>

                    <div className="post-info">
                        <div className="image-container post-image" onClick={() => {updateFullscreenImage(true)}}>
                            <ImageWithFallBack src={image} image_type="Grimoire" alt={name} />
                        </div>

                        <div className="post-content">
                            {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                        </div>
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>}
                            {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>

                    <div className="bg-clickable-post" onClick={openFullPost}/>            
                </div>
            </>
        );
    }
    else if(type === "Template") {
        return(
            <div className="post-container template">
                <div className="top-row">
                    <h3></h3>
                    <span className="post-category"> </span>
                </div>

                <div className="post-info">

                    <div className="post-content"> 
                        <div className="description short" />
                        <div className="description short" />
                        <div className="description short" />
                    </div>

                    <div className="image-container post-image" ></div>
                </div>

                <div className="bottom-row">

                    {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                        {liked && <img src={LikedIcon} className="liked"/>}
                        {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                    </div> */}

                    <div className="align-right">
                        <span></span>
                    </div>
                </div>       
            </div>
        );
    }
    else {
        return(
            <>
                {displayFullImage && <FullscreenImage image={image!} type="icon" close={closeFullscreenImage} />}
                <div className="post-container quest" id={hash.toString()}>
                    <div className="top-row">
                        <h3>{name}</h3>
                        <span className="post-category"> {type} 
                            {/* <span className="image-container"><img src={LoreEntryIcon} /></span> */}
                        </span>
                    </div>

                    <div className="post-info">
                        <div className="image-container post-image" onClick={() => {updateFullscreenImage(true)}}>
                            <ImageWithFallBack src={image} image_type={type} alt="" />
                        </div>

                        <div className="content">
                            {/* {subtitle.length !== 0 && <div className="flavor-text">{convertStringtoHTML(subtitle)}</div>} */}

                            {description !== null && <div className="description short">{convertStringtoHTML(description!)}...</div>}
                        </div>
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>} {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span>{released}</span> <ReleasedIcon value={released} />
                        </div>
                    </div>
                
                    <div className="bg-clickable-post" onClick={openFullPost}/>
                </div>
            </>
        );
    }
}
